module.exports = __webpack_public_path__ + "img/payment-due.87c6b1f3.svg";